import diet0 from "../images/mealPreferences/specificdiet/diet0.webp";
import diet1 from "../images/mealPreferences/specificdiet/diet1.webp";
import diet2 from "../images/mealPreferences/specificdiet/diet2.webp";
import diet3 from "../images/mealPreferences/specificdiet/diet3.webp";
import diet4 from "../images/mealPreferences/specificdiet/diet4.webp";
import diet5 from "../images/mealPreferences/specificdiet/diet5.webp";
import diet6 from "../images/mealPreferences/specificdiet/diet6.webp";
import diet7 from "../images/mealPreferences/specificdiet/diet7.webp";

const SpecificDietImage = {
  diet0: diet0,
  diet1: diet1,
  diet2: diet2,
  diet3: diet3,
  diet4: diet4,
  diet5: diet5,
  diet6: diet6,
  diet7: diet7,
};

export default SpecificDietImage;
